import React from 'react';
import cn from 'classnames';
import moment from 'moment';
import HubspotForm from 'react-hubspot-form';
import Spinner from 'react-scale/components/elements/spinner';

import Section from 'react-scale/components/elements/section';
import CTA from 'react-scale/components/tailwind/CTA';

import { mq } from 'react-scale/components/website/big/Themes';
import getCookie from 'react-scale/lib/util/get-cookie';

const setHiddenUTMFields = () => {
  let utmParams = {};
  try {
    utmParams = JSON.parse(window.localStorage.getItem('utm_params') || '{}');
    Object.keys(utmParams).forEach(property => {
      const utmField = document.querySelector(`input[name=${property}]`);
      if (utmField) {
        // @ts-ignore
        utmField.value = utmParams[property] ?? '';
      }
    });
  } catch (error) {
    // NOTE: ignore error, using localStorage/sessionStorage is disabled in incognito.
  }
};

class HubspotFormWrapper extends React.Component {
  // eslint-disable-next-line react/sort-comp
  constructor(props) {
    super(props);
    // @ts-ignore
    this.formWrapper = React.createRef();
    // @ts-ignore
    this.link = React.createRef();
  }

  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    download: null,
    url: null
  };

  componentDidMount() {
    window.addEventListener('message', this.hubSpotEventHandler);
    // @ts-ignore
    if (this.props.download?.type === 'archive') {
      // @ts-ignore
      this.link.current.click();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.hubSpotEventHandler);
  }

  hubSpotEventHandler = async event => {
    const { data, type, id, eventName } = event.data;
    // @ts-ignore
    const { formId, pathName, router } = this.props;
    if (type === 'hsFormCallback' && eventName === 'onFormSubmit') {
      if (id === formId) {
        const hutk = getCookie('hubspotutk');

        const body = {
          submittedAt: moment.utc().valueOf(),
          fields: [...data],
          context: {
            ...(hutk ? { hutk } : undefined),
            pageName: document.querySelector('title').text,
            pageUri: window.location.href
          }
        };

        const bodyStr = JSON.stringify(body);

        const result = await fetch(
          `https://api.hsforms.com/submissions/v3/integration/submit/4823527/${formId}`,
          {
            method: 'POST',
            body: bodyStr,
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        if (result.ok && pathName) {
          router.push(`${pathName}/thank-you`);
        }
      }
    }
  };

  render() {
    // @ts-ignore
    const { title, subtitle, image, download, archiveName, portalId, formId } = this.props;
    const { src, alt, type, background } = image;

    return (
      <div className="hubspot-download">
        <Section>
          <div className="grid md:grid-cols-2 md:gap-x-10">
            <div>
              {download && (
                <div className="download-wrapper">
                  <h4 className="mb-4 text-2xl">Thanks for Downloading</h4>
                  {download.type === 'archive' && (
                    <h6>
                      {/* @ts-ignore */}
                      <a ref={this.link} href={download.href} download={archiveName}>
                        Download Again
                      </a>
                    </h6>
                  )}
                  {download.type === 'link' && (
                    <CTA
                      cta={{
                        text: 'Download Now',
                        href: download.href,
                        colors: {
                          bg: 'bg-utility-yellow',
                          text: 'text-white'
                        }
                      }}
                    />
                  )}
                </div>
              )}
              {!download && (
                <>
                  <h3 className="mb-4 text-3xl">{title}</h3>
                  <p className="mb-10 text-lg">{subtitle}</p>
                  {/* @ts-ignore */}
                  <div className="form" ref={this.formWrapper}>
                    <HubspotForm
                      portalId={portalId}
                      formId={formId}
                      target=".form"
                      submitButtonClass={cn(
                        'font-medium text-base px-6 py-3 leading-relaxed inline-block rounded-full whitespace-nowrap cursor-pointer',
                        'bg-black',
                        'text-white',
                        'hs-button'
                      )}
                      onReady={() => setHiddenUTMFields()}
                      loading={<Spinner size="lg" />}
                    />
                  </div>
                </>
              )}
            </div>
            <div>
              <div className="image-wrapper">
                <img className={type} src={src} alt={alt} />
              </div>
            </div>
          </div>
        </Section>
        <style jsx>{`
          .hubspot-download {
            text-align: center;
          }
          @media (min-width: ${mq.md}) {
            .hubspot-download {
              text-align: left;
            }
          }

          .image-wrapper {
            background: ${background};
            height: 100%;
            display: none;
          }
          @media (min-width: ${mq.md}) {
            .image-wrapper {
              display: block;
            }
          }

          .image-wrapper,
          .download-wrapper {
            height: 790px;
          }
          @media (min-width: ${mq.lg}) {
            .image-wrapper,
            .download-wrapper {
              height: 673px;
            }
          }

          .image-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          img {
            margin: 0 auto;
          }
          img.full {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          img.dataset {
            width: 60%;
            height: auto;
          }

          .download-wrapper {
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          }
        `}</style>
        <style jsx global>{`
          .hubspot-download iframe {
            max-width: 280px;
            margin: 0 auto;
          }
          @media (min-width: ${mq.md}) {
            .hubspot-download iframe {
              max-width: none;
              margin: 0;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default HubspotFormWrapper;
